<template>
  <section id="testimonies" data-light-menu="true" :data-section="$t('anchors.experiences')">
    <div class="testimonies testimonies__background section">
      <SwiperTestimonies v-if="mq.mdPlus" :testimonies="content.elements" v-reveal />
      <MobileSwiperTestimonies v-else :testimonies="content.elements" />
      <RoundTextButton
        place="testimonies"
        :text="content.round_button"
        :to="{ name: 'home', hash: `#${$t('anchors.jobs')}` }"
      />
    </div>

    <Image class="image__background" :source="content.image" v-reveal="{ delay: 250 }" />
  </section>
</template>

<script>
import Image from '@/components/global/Image.vue'
import RoundTextButton from '@/components/small/RoundTextButton.vue'
import MobileSwiperTestimonies from '@/components/swipers/MobileSwiperTestimonies.vue'
import SwiperTestimonies from '@/components/swipers/SwiperTestimonies.vue'

export default {
  name: 'TestimoniesSection',
  components: { Image, MobileSwiperTestimonies, RoundTextButton, SwiperTestimonies },
  inject: ['mq'],
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
